import React, { useState } from 'react';
import CircleButton from '../CircleButton';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import EditValveDeficiencyModal from '../../pages/valves/EditValveDeficiencyModal';

const ValveDeficiencyTableRow = ({ valveDeficiency, onDelete, onEdit }) => {
    const [startDelete, setStartDelete] = useState(false);
    const [editValveDeficiencyModalOpen, setEditValveDeficiencyModalOpen] = useState(false);

    const handleEdit = () => {
        setEditValveDeficiencyModalOpen(false);
        onEdit();
    };

    return (
        <tr id={valveDeficiency.id}>
            <td>{valveDeficiency.deficiencyType}</td>
            <td>{valveDeficiency.note}</td>
            <td>{valveDeficiency.resolved ? 'Yes' : 'No'}</td>
            <td className="action-cell">
                <div className="list-actions">
                    <CircleButton icon={faEdit} type="primary" title="Edit" onClick={() => setEditValveDeficiencyModalOpen(true)} />
                    <CircleButton icon={faTrashAlt} type="danger" title="Delete" onClick={() => setStartDelete(true)} />
                </div>
                {startDelete && (
                    <div className="row-confirm">
                        <div className="form-actions">
                            <span>Are you sure you want to delete this record?</span>
                            <button type="button" className="btn btn-primary" onClick={() => onDelete(valveDeficiency.id)}>Yes</button>
                            <button type="button" className="btn btn-secondary" onClick={() => setStartDelete(false)}>No</button>
                        </div>
                    </div>
                )}
            </td>
            <EditValveDeficiencyModal open={editValveDeficiencyModalOpen} valveDeficiency={valveDeficiency} onCancel={() => setEditValveDeficiencyModalOpen(false)} onComplete={handleEdit} />
        </tr>
    );
};

export default ValveDeficiencyTableRow;